// @ts-nocheck
const Spacer = ({ margin }: { margin?: string }) => {
  return (
    <div
      style={{
        margin,
      }}
    />
  )
}

export default Spacer
